import {Pipe, PipeTransform} from '@angular/core';

import {GridEditTemplate} from '../../../dialogs/models/create-new-view.enum';
import {IColumn} from '../../../dialogs/models/create-new-view.interface';

@Pipe({
  name: 'formatValue',
  pure: true
})
export class FormatValuePipe implements PipeTransform {
  transform(value: any, args?: any): string {
    const {
      field: {options},
      editTemplate
    } = args.column as IColumn;

    let transformedValue;

    if (
      editTemplate !== GridEditTemplate.boolean &&
      editTemplate !== GridEditTemplate.predefined &&
      editTemplate !== GridEditTemplate.predefinedList
    ) {
      transformedValue = value;
    } else if (editTemplate === GridEditTemplate.predefinedList) {
      transformedValue = value?.map(
        val => options.find(option => option.value === val)?.displayValue
      );
    } else {
      transformedValue = options.find(option => option.value === value)?.displayValue;
    }

    return Array.isArray(transformedValue)
      ? this.arrayToString(transformedValue)
      : transformedValue;
  }

  private arrayToString(values: any[]): string {
    return values.join(', ');
  }
}
